module.exports = __webpack_public_path__ + "img/email.8c995b96.svg";